import type { FaireProductEntity } from "../../entity_types/product";

export const p_tt7bwx4gz3: FaireProductEntity = {
  token: "p_tt7bwx4gz3",
  type: "product",
  name: "Variety of Deadstock Vintage Rings",
  brandToken: "b_2yc6uznjzg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d7a033a8819d0c388af16c6aa8d27be2bc68983137b290c1e4a12cc74b3c5904.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2005222d4e0cde02683cbce44e9bc02c24bc641f1c9b241cd6daed976e1102f8.jpeg",
    "https://cdn.faire.com/fastly/985ab778708d4d1c5457254171a4b1c5e00a54679493569f894beb125b2fe791.jpeg",
    "https://cdn.faire.com/fastly/ed15a60539e0388cf5e22bbd6151d02224e7aaa898f26ed93aa7a0ab4460b43d.jpeg",
    "https://cdn.faire.com/fastly/9a010594490d74f4dd53e0012755d9592938f3f4a64af83ff99507d7bbbaea64.jpeg",
    "https://cdn.faire.com/fastly/0b42e28a2a2affba75a96e0fc6d27fd8fde701b7feba36ae166f6f3c02b66a3a.jpeg",
    "https://cdn.faire.com/fastly/14a9036b1808d3b9e62d390881de2d06920b4aa2412d94f9f1cc897bc471e63c.jpeg",
  ],
  priceDollars: 11.09,
  description:
    "Variety of gold and silver-plated vintage rings with rhinestones, gemstones, glass, metal, resin, lucite, cameos, cabochons, etc. Diverse styles, but all with a vintage look. All deadstock. Some are set sizes and others are adjustable.\n\nPlease Note: The photos are an example / representation of what you will receive, not the actual products. I will do my best to include a nice variety of different styles/colors/metals/sizes/etc.\n\n*Minimum order of 10 rings. Wholesale $7.50/ring - MSRP $15/ring",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:35.227Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
